import {Checkerboard} from "./Checkerboard";
import {Rules} from "@model/Rules";

export class State {
    ihm;
    connection;

    checkerboard;

    round;

    player;
    gameId;

    constructor(ihm, connection) {
        this.ihm = ihm;
        this.connection = connection;
        this.round = 1;
    }

    initGame(matrix, player, gameId) {
        this.player = player;
        this.gameId = gameId;
        this.checkerboard = new Checkerboard(matrix);

        this.updateView();
    }

    updateView() {
        this.ihm.updateView(this.checkerboard, this.player, this.round);
    }

    movePawn(sourceX, sourceY, destX, destY, sendWebsocket = false) {
        const originPawn = this.checkerboard.getPawn(sourceX, sourceY);
        const destPawn = this.checkerboard.getPawn(destX, destY);

        originPawn.x = destX;
        originPawn.y = destY;

        originPawn.layer = 1;
        if (destPawn) {
            originPawn.layer = 2;
        } else {
            originPawn.layer = 1;
        }
        originPawn.viewColor = this.calcPawnColor(destX, destY);

        if (sendWebsocket) {
            this.connection.sendMove(sourceX, sourceY, destX, destY);
        }

        this.round = this.round === 1 ? 2 : 1;

        this.updateView();
    }

    eatPawn(x, y) {
        const pawnLayer1 = this.checkerboard.getPawn(x, y, 1);
        const pawnLayer2 = this.checkerboard.getPawn(x, y, 2);

        if (pawnLayer1 && pawnLayer2) {
            pawnLayer1.eaten = true;
            this.checkerboard.removePawn(pawnLayer1.x, pawnLayer1.y);
            pawnLayer2.layer = 1;

            pawnLayer2.viewColor = this.calcPawnColor(pawnLayer2.x, pawnLayer2.y);

            this.updateView();
        }
    }

    calcPawnColor(x, y) {
        const checkerboardTile = this.checkerboard.getTile(x, y);
        let result = checkerboardTile ? checkerboardTile.color : 0;

        const pawnOnTile = this.checkerboard.getAllPawnsOnTile(x, y);
        if (pawnOnTile.length === 0) {
            return result;
        }

        const topLayer = Math.max(...pawnOnTile.map(pawn => pawn.layer));
        for (const pion of pawnOnTile) {
            if (pion.layer <= topLayer) {
                result |= pion.color;
            }
        }

        return result;
    }
}